import { Lock, Unlock } from 'lucide-react';
import { useClientLock } from '@/features/auth/contexts/ClientLockContext';
import { useLanguage } from '@/shared/contexts/LanguageContext';

const LABELS = {
  lock: { fr: 'Mode client', en: 'Client mode', es: 'Modo cliente' },
  unlock: { fr: 'Déverrouiller', en: 'Unlock', es: 'Desbloquear' },
} as const;

/**
 * Single button to toggle the client lock. When unlocked → engages it.
 * When locked → opens the PIN modal to release it.
 * Hidden if no PIN is configured (no lock is possible).
 */
export function ClientLockToggle({ className = '' }: { className?: string }) {
  const { isLocked, isPinAvailable, lock, unlock } = useClientLock();
  const { language } = useLanguage();

  if (!isPinAvailable) return null;

  return (
    <button
      onClick={isLocked ? unlock : lock}
      className={`touch-button px-4 py-3 rounded-xl flex items-center gap-2 text-sm font-semibold ${
        isLocked
          ? 'bg-primary text-primary-foreground'
          : 'bg-secondary text-secondary-foreground'
      } ${className}`}
    >
      {isLocked ? <Unlock size={18} /> : <Lock size={18} />}
      {isLocked ? LABELS.unlock[language] : LABELS.lock[language]}
    </button>
  );
}
